var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 17.0833H6.25",
    stroke: "black",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 15.4167C10.5 15.6929 10.2761 15.9167 10 15.9167C9.72386 15.9167 9.5 15.6929 9.5 15.4167H10H10.5ZM10 15.4167H9.5V13.3334H10H10.5V15.4167H10Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 7.91675H11.25",
    stroke: "black",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.58317 12.0834C4.58317 12.0834 2.9165 10.8334 2.9165 8.75008C2.9165 8.11229 2.9165 7.5526 2.9165 7.08296C2.9165 6.16249 3.6627 5.41675 4.58317 5.41675C5.50365 5.41675 6.24984 6.16294 6.24984 7.08342V7.91675",
    stroke: "black",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4168 12.0834C15.4168 12.0834 17.0835 10.8334 17.0835 8.75008C17.0835 8.11229 17.0835 7.5526 17.0835 7.08296C17.0835 6.16249 16.3373 5.41675 15.4168 5.41675C14.4964 5.41675 13.7502 6.16294 13.7502 7.08342V7.91675",
    stroke: "black",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 9.10919V6.58325C13.75 5.47868 12.8546 4.58325 11.75 4.58325H8.25C7.14543 4.58325 6.25 5.47868 6.25 6.58325V9.10918C6.25 10.4466 6.9184 11.6955 8.0312 12.4374L9.4453 13.3801C9.7812 13.6041 10.2188 13.6041 10.5547 13.3801L11.9688 12.4374C13.0816 11.6955 13.75 10.4466 13.75 9.10919Z",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.3bad92097862919f534995b4fc79f56e.svg";
export { ForwardRef as ReactComponent };